import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'
import { FaEnvelope, FaIdCard, FaUser } from 'react-icons/fa'

export default function StaffOverview() {
    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')

    const [staff, setStaff] = useState(null)
    const [loading, setLoading] = useState(false)

    const fetchStaff = async() => {
        try{
            setLoading(true)

            const res = await axios.get(`${config.baseurl}get_staff/${id}/`, {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Token ${token}`
                }
            })
            console.log('Staff:', res.data)

            if(res.status === 200){
                const staffData = Array.isArray(res.data)
                    ? res.data.find((item) => item.id === Number(id))
                    : res.data.data

                if(staffData){
                    setStaff(staffData)
                }else{
                    toast.error('Staff not found')
                }
            }else{
                toast.error('Failed to fetch data')
            }
        }catch(error){
            console.log('Error:', error.response?.data || error)
            
            const message = 
                error.response?.data?.message ||
                error.response?.data?.error ||
                'Failed to fetch staff details'
            toast.error(message)
        }finally{
            setLoading(false)
        }
    }

    useEffect(() => {
        if(id){
            fetchStaff()
        }
    },[id])

    if (loading) {
        return (
            <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
                <AdminHeader />

                <div className='flex items-center justify-center h-[70vh]'>
                    <p className='text-slate-500'>Loading staff details...</p>
                </div>
            </div>
        )
    }

    if (!staff) {
        return (
            <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
                <AdminHeader />

                <div className='flex items-center justify-center h-[70vh]'>
                    <p className='text-slate-500'>Staff details not found.</p>
                </div>
            </div>
        )
    }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
        <AdminHeader/>

        <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
            <h1 className='mt-1 text-3xl font-bold'>
            Staff Basic Information
            </h1>
            <p className="mt-2 text-sm text-slate-500">
            View registered Staff in detail.
            </p>
        </div> 

        <div className='max-w-7xl mx-auto px-6'>
            <div className='bg-white border border-slate-200 rounded-xl shadow-sm p-6'>
                <div className='flex items-center gap-5'>
                    <div>
                        <h2 className='text-xl font-bold'>{staff.first_name}{staff.last_name}</h2>
                        <p className='text-sm text-slate-500 mt-1'>
                            {staff.role || 'No Role'}
                            {staff.department_name}
                        </p>
                    </div>
                </div>
            </div>

            <div className='grid grid-cols-2 md:grid-cols-1 gap-6 mt-6'>
                <InfoCard
                    title='Personal Information'
                    icon={<FaUser/>}
                >
                    <div className='grid grid-cols-2 md:grid-cols-1 gap-5'>
                        <InfoItem
                            label='First Name'
                            value={staff.first_name}
                        />

                        <InfoItem
                            label='Last Name'
                            value={staff.last_name}
                        />

                        <InfoItem
                            label='Age'
                            value={staff.age}
                        />

                        <InfoItem
                            label='Gender'
                            value={staff.gender}
                        />

                        <InfoItem
                            label='Date of Brith'
                            value={staff.dob}
                        />
                    </div>
                </InfoCard>

                <InfoCard
                    title='Contact Information'
                    icon={<FaEnvelope/>}
                >
                    <div className='space-y-5'>
                        <InfoItem
                            label='Email'
                            value={staff.email}
                        />

                        <InfoItem
                            label='Phone Number'
                            value={staff.phone}
                        />

                        <InfoItem
                            label='Address'
                            value={staff.address}
                        />
                    </div>
                </InfoCard>

                <InfoCard
                    title='Professional Information'
                    icon={<FaIdCard/>}
                >
                    <InfoItem
                        label='Role'
                        value={staff.role}
                    />

                    <InfoItem
                        label='Department'
                        value={staff.department}
                    />

                </InfoCard>


                <InfoCard
                    title='Identification'
                    icon={<FaIdCard/>}
                >
                    <InfoItem
                        label='Aadhaar Number'
                        value={staff.aadhaar_no}
                    />
                </InfoCard>

            </div>
        </div>
    </div>
  )
}

function InfoCard({title, icon, children}){
    return(
        <div className='bg-white border border-slate-200 rounded-xl shadow-sm'>
            <div className='flex items-center gap-3 px-6 py-5 border-b border-slate-200'>
                <div className='w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center'>{icon}</div>
                <h2 className='font-semibold'>{title}</h2>
            </div>
            <div className='p-6'>
                {children}
            </div>
        </div>
    )
}

function InfoItem({label, value}){
    return(
        <div>
            <p className='text-xs font-medium text-slate-500 uppercase tracking-wide'>{label}</p>
            <p className='mt-1 text-sm font-semibold break-words'>{value || '-'}</p>
        </div>
    )
}
